import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { CLINIC } from "@/lib/clinicInfo";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/cataract", label: "Cataract" },
  { to: "/eyelid-oculoplasty", label: "Eyelid & Oculoplasty" },
  { to: "/eye-checkup-at-home", label: "Home Visit" },
  { to: "/services", label: "Services" },
  { to: "/blog", label: "Blog" },
  { to: "/contact", label: "Contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 bg-background/85 backdrop-blur-md border-b border-border">
      <div className="container-wide flex items-center justify-between h-16 sm:h-20">
        <Link to="/" className="flex items-center gap-3" data-testid="header-logo">
          <img
            src={CLINIC.logo}
            alt="Nehchal Eye Centre - Redefining Eye Care logo"
            className="h-11 sm:h-12 w-auto object-contain"
            loading="eager"
          />
          <div className="hidden sm:block lg:hidden xl:block leading-tight border-l border-border pl-3">
            <div className="font-serif text-base text-primary whitespace-nowrap">Nehchal Eye Centre</div>
            <div className="text-[10px] tracking-[0.2em] uppercase text-foreground/60">Sector 32 · Noida</div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-4 xl:gap-6" data-testid="header-nav">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.to === "/"}
              className={({ isActive }) =>
                `text-sm whitespace-nowrap transition-colors ${isActive ? "text-primary" : "text-foreground/70 hover:text-foreground"}`
              }
              data-testid={`nav-link-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={`tel:${CLINIC.phoneRaw}`}
            className="hidden sm:inline-flex lg:hidden 2xl:inline-flex items-center gap-2 text-sm text-primary whitespace-nowrap hover:opacity-80"
            data-testid="header-call-link"
          >
            <Phone className="h-4 w-4" />
            {CLINIC.phone}
          </a>
          <Link
            to="/contact"
            className="hidden sm:inline-flex items-center whitespace-nowrap rounded-full bg-primary text-primary-foreground px-4 py-2 text-sm hover:bg-primary/90 transition-colors"
            data-testid="header-book-btn"
          >
            Book Appointment
          </Link>
          <button
            onClick={() => setOpen((v) => !v)}
            className="lg:hidden inline-flex items-center justify-center h-10 w-10 rounded-full border border-border"
            aria-label="Toggle menu"
            data-testid="header-menu-toggle"
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-border bg-background" data-testid="mobile-nav">
          <div className="container-wide py-4 flex flex-col gap-3">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.to === "/"}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `text-base py-2 border-b border-border/60 ${isActive ? "text-primary" : "text-foreground/80"}`
                }
                data-testid={`mobile-nav-link-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                {n.label}
              </NavLink>
            ))}
            <a
              href={`tel:${CLINIC.phoneRaw}`}
              className="mt-2 inline-flex items-center justify-center gap-2 rounded-full bg-primary text-primary-foreground px-4 py-3 text-sm"
              data-testid="mobile-call-btn"
            >
              <Phone className="h-4 w-4" /> Call {CLINIC.phone}
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
